exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ========== Color =========== */\n/* ========== Background Colors =========== */\n/* ========== Grid =========== */\n/* ========== Text =========== */\n/* ========== Inputs =========== */\n/* ========== Selection Controls =========== */\n/* ========== Lists =========== */\n/* ========== Elevation =========== */\n/* ========== Layout Peaks  =========== */\n/* ========== Typography Font Sizes =========== */\n/* ========== Typography Line Heights =========== */\n/* ========== Typography Letter Spacings =========== */\n.eds-structure__main {\n  background-color: #F8F7FA; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js??ref--2-3!./src/pages/Base/Base.scss
// module id = 2402
// module chunks = 0